/**
 * The handle inside whatever was typed — or null when no handle is in there.
 * X's own shape: 1–15 of [a-z0-9_], with or without the leading `@`.
 *
 * (This file once carried `goKnock`, the navigate-to-a-door helper; the Search
 * room is the one place that starts a knock from text now, and it navigates
 * through the router directly. The parser stays because the rule it encodes —
 * what counts as an address — is referenced anywhere text might be a handle.)
 */
export function parseKnockHandle(raw: string): string | null {
  const handle = raw.trim().replace(/^@/, "").toLowerCase();
  return /^[a-z0-9_]{1,15}$/.test(handle) ? handle : null;
}
